import React from 'react';

import type { EmptyStateHandler } from '@atlaskit/editor-common/types';

import { MarketplaceAppsContainer } from './index';

export const getMarketplaceAppsContainer: EmptyStateHandler = ({
	searchTerm,
	mode,
}): React.ReactElement<any> | null => {
	if (!searchTerm) {
		return null;
	}
	return <MarketplaceAppsContainer searchTerm={searchTerm} mode={mode} />;
};
